/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddressNewApiModel { 
    streetName?: string | null;
    cityName?: string | null;
    zipValue?: string | null;
    countryName?: string | null;
    registerNumber?: number | null;
    descriptiveNumber?: string | null;
}

